<app-privacy mode="dialog"></app-privacy>
    
<mat-dialog-actions [align]="'center'">
    <button matButton="elevated" color="warn" mat-dialog-close cdkFocusInitial>
        {{ data.buttonNo }}
    </button>
</mat-dialog-actions>